import { SUBSCRIPTION_SCREEN_ID } from 'constants/analytics';

import { ActionEventAction, ElementEventAction } from 'services/Analytics/core';
import type { EventDataOverrides } from 'services/Analytics/core/Interfaces/Events';
import { changePathNameToScreenId } from 'services/Analytics/helpers';

import { trackClick } from './mainTrackers';

export const sendAnalyticSideBarElementClick = (
    actionEvent: ActionEventAction,
    eventDataOverrides?: EventDataOverrides
) => {
    const screenId = changePathNameToScreenId();

    trackClick({
        elementEvent: ElementEventAction.button,
        actionEvent,
        isEventSchemaKey: screenId.includes(SUBSCRIPTION_SCREEN_ID),
        ...(eventDataOverrides && { eventDataOverrides }),
    });
};
